/**
 * @fileoverview GET handler for the Decisioning Studio Performance Report data endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdPerformanceReportData } from "./constants";
import type {
  GetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportDataParams,
  GetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportDataResult,
} from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportDataResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportData = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdPerformanceReportData,
  (
    signal: AbortSignal,
    {
      appGroupId,
      dsaId,
      lookbackPeriod,
      baseRegime,
      comparisonRegime,
    }: GetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportDataParams
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportDataResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/performance_report/data`,
      "GET",
      {
        lookback_period: lookbackPeriod,
        base_regime: baseRegime,
        comparison_regime: comparisonRegime,
      },
      { signal },
      {
        propagateFetchRequestError: false,
      }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdPerformanceReportDataResult
);
